import { Col, Row } from 'reactstrap';
import { BsClipboardDataFill } from 'react-icons/bs';
import ReportListWidget from './ReportWidgets/ReportListWidget';
import ReportListLoadingWidget from './ReportWidgets/ReportListLoadingWidget';
import ReportListEmptyWidget from './ReportWidgets/ReportListEmptyWidget';
import PageHeader from '../../sharedComponents/Header/PageHeader';
import useReports from './useReports';
import ManufacturerSelect from "../../sharedComponents/ManufacturerSelect/ManufacturerSelect";

const Reporting = (props) => {
    const { useReportsList, portalTypeReportsList, userReportsList, favoritedReportsList, recentReportsList } = useReports();
    const { data, isLoading, error } = useReportsList();
    const reportingPages = {
        'allReports': 'All Reports',
        'recentReports': 'Recent Reports',
        'userReports': 'Created By You',
        'favoritedReports': 'Favorited Reports'
    }
    const pageSubtitle = reportingPages[props.page] || 'List of Reports';

    const filteredReports = (() => {
        switch (props.page) {
            case 'allReports':
                return portalTypeReportsList;
            case 'recentReports':
                return recentReportsList;
            case 'userReports':
                return userReportsList;
            case 'favoritedReports':
                return favoritedReportsList;
            default:
                return data;
        }
    })();

    return (
        <>
        <Row className='mx-0' style={{height: '100%'}}>
            <Col className='p-0' style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                <PageHeader title='Reports' subtitle={pageSubtitle} icon={<BsClipboardDataFill fill='url(#icon-gradient)'/>}/>
                <Row className='px-3'>
                    <Col className="mt-2 mx-2 pe-0">
                        <ManufacturerSelect />
                    </Col>
                </Row>
                <Row className='px-2' style={{flexGrow: '1'}}>
                    <Col style={{height: '100%'}}>
                        {isLoading && 
                        <ReportListLoadingWidget />
                        }
                        {(filteredReports?.length === 0 && !isLoading) && 
                        <ReportListEmptyWidget />
                        }
                        {(filteredReports?.length > 0 && !isLoading) &&
                        <ReportListWidget reports={filteredReports}/>
                        }
                        {error &&
                        <div>
                            Something went wrong loading this page.
                        </div>
                        }
                    </Col>
                </Row>
            </Col>
        </Row>
        </>
    );
}

export default Reporting; 